import { render, staticRenderFns } from "./ContatoDoIrmao.vue?vue&type=template&id=345d6a78"
import script from "./ContatoDoIrmao.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContatoDoIrmao.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports